import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { HeadBar, SubNavigationBar, SubNavigationItem } from '../shared/components'
import { FaIcon, faUsers } from '@/lib/fa'
import { USERS_ROUTES } from './routes-typed'
import { useLocation } from 'react-router-dom'
import clx from 'classnames'

type Props = {
  children: React.ReactNode
  companyId: string
}

export const UsersLayout = ({ children, companyId }: Props) => {
  const { t } = useLocalize()
  const cid = companyId
  // Zakładka ról przewija się w środku (pasek Zapisz zostaje na dole), jak moduły z heightScreen.
  const fitScreen = useLocation().pathname.includes('/usersModule/roles')

  return (
    <div
      className={clx(
        'module-users tw-padding-4 tw-m-1 tw-flex tw-min-w-[900px] tw-flex-[1] tw-flex-col tw-overflow-y-hidden tw-rounded-xl tw-border tw-border-base-300 tw-bg-base-100 tw-text-content-base',
        fitScreen && 'tw-max-h-[calc(100vh-0.5rem)]',
      )}
    >
      <HeadBar
        title={t('dashboard.users')}
        icon={<FaIcon icon={faUsers} className="tw-text-content-secondary" />}
      />

      <SubNavigationBar>
        <SubNavigationItem
          to={USERS_ROUTES.usersList.buildPath({ companyId: cid })}
        >
          {t('usersModule.tabs.users')}
        </SubNavigationItem>
        <SubNavigationItem to={USERS_ROUTES.rolesList.buildPath({ companyId: cid })}>
          {t('usersModule.rolesTab.tabList')}
        </SubNavigationItem>
        {/* Grupy i etykiety są na razie ukryte: grupy należą do użytkownika, a nie do firmy
            (ten sam zestaw w każdej firmie), a etykiet nie da się jeszcze do niczego przypiąć. */}
      </SubNavigationBar>

      <div className="tw-flex tw-min-h-0 tw-w-full tw-flex-1">{children}</div>
    </div>
  )
}
